<template>
    <div class="d-flex flex-column flex-root">
        <!--begin::Login-->
        <div class="login login-3 login-signin-on d-flex flex-row-fluid" id="kt_login">
            <div class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
                <locale-switcher></locale-switcher>
            </div>
            <div class="d-flex flex-center bgi-size-cover bgi-no-repeat flex-row-fluid" :style="'background-image: url(' + $publicPath + 'media/bg/bg-1.jpg);'">
                <LoginBox />
            </div>
        </div>
        <!--end::Login-->
    </div>
</template>

<script>
    import LoginBox from '@/components/LoginBox.vue';
    import LocaleSwitcher from '@/components/LocaleSwitcher.vue';

    export default {
        name: 'Login',
        components: {
            LoginBox,
            'locale-switcher': LocaleSwitcher,
        }
    }
</script>

<style scoped>
    .outer {
        display: table;
        position: absolute;
        width: 100%;
        height: 100%;
    }
</style>
